









import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import exportView from "./export.vue";
const root = namespace("root");
@Component({ components: { exportView } })
export default class EmportPage extends Vue {
  @root.State ddCodes;
  created() {
    this.$dd.register(["K1_EXPORT_FILE_TYPE"]).query();
  }
  get tabOptions() {
    const apiList = this.ddCodes.K1_EXPORT_FILE_TYPE;
    return [{ label: "全部", value: "" }].concat(apiList);
  }
}
